/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchFiltersSchemaCertificationStatus = typeof SearchFiltersSchemaCertificationStatus[keyof typeof SearchFiltersSchemaCertificationStatus];


export const SearchFiltersSchemaCertificationStatus = {
  any: 'any',
  not_expired: 'not_expired',
  verified_current: 'verified_current',
} as const;
